<template>
  <div>
    <div class="footer-main">
      <div class="footer-top">
        <div class="footer-brand">
          <div class="footer-logo">
            Enbarr<span class="footer-ai">.ai</span>
          </div>
          <p class="footer-brand-text">
            {{ localize('FOOTER_BRAND_DESC') }}
          </p>
        </div>
        <div class="footer-columns">
          <div class="footer-col">
            <div class="footer-col-title">{{ localize('FOOTER_PRODUCT') }}</div>
            <div class="footer-link" @click="gotoTab('technology')">{{ localize('TEXT_TECHNOLOGY') }}</div>
            <div class="footer-link" @click="gotoTab('audit')">{{ localize('TEXT_AUDIT') }}</div>
            <div class="footer-link" @click="gotoTab('about')">{{ localize('TEXT_ABOUT') }}</div>
          </div>
          <div class="footer-col">
            <div class="footer-col-title">{{ localize('FOOTER_LEGAL') }}</div>
            <div class="footer-link" @click="gotoTab('terms')">{{ localize('TEXT_TERMS_CONDITIONS') }}</div>
            <div class="footer-link" @click="gotoTab('privacy')">{{ localize('FOOTER_PRIVACY') }}</div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-bottom-inner">
          <div class="footer-copyright">
            <img class="footer-flag" src="https://flagcdn.com/w40/jp.png" alt="JP" width="20" height="14">
            &copy; {{ currentYear }} CompDeep G.K.
          </div>
          <div class="footer-socials">
            <a
              href="https://www.linkedin.com/company/compdeep/"
              target="_blank"
              rel="noopener noreferrer"
              class="footer-social-link"
              v-html="getRawIcon('ICON_LINKEDIN')"
            />
            <a
              href="https://x.com/compdeep1"
              target="_blank"
              rel="noopener noreferrer"
              class="footer-social-link"
              v-html="getRawIcon('ICON_X')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {inject, ref} from "vue";
import {translationStore} from "@/stores/translation";
import {iconStore} from "@/stores/icon";

export default {
    "name": "SVFooter",
    "components": {
    },
    "props": {
    },
    setup () {

        const router = inject("router"),
            translation = translationStore(),
            icon = iconStore(),
            currentYear = new Date().getFullYear(),
            getRawIcon = function (i) {

                return icon.get(i);

            },
            isLang = function (lang) {

                return translation.getLang().indexOf(lang);

            },
            gotoTab = function (t) {

                router.push({"path": `/${t}`,
                    "name": t});

            };

        return {"localize": translation.localize,
            translation,
            currentYear,
            getRawIcon,
            gotoTab,
            isLang};

    }
};

</script>
<style scoped>
.footer-main {
  --purple: #7c3aed;
  --magenta: #ec4899;
  --cyan: #06b6d4;
  --text-primary: #0f0d15;
  --text-secondary: #4a4458;
  --text-muted: #6b6280;
  --bg-footer: #f8f7fb;
  --border-subtle: #d8d3e3;
  --font-heading: 'Space Grotesk', sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
  --gradient-text: linear-gradient(135deg, #7c3aed, #6366f1, #06b6d4);
  --accent-purple: #7c3aed;

  width: 100%;
  margin-top: 0;
  background: var(--bg-footer);
  border-top: 3px solid;
  border-image: linear-gradient(90deg, #7c3aed, #6366f1, #06b6d4) 1;
  border-radius: 0px;
  box-shadow: none;
  position: relative;
  z-index: 1;
}
:root[data-theme="dark"] .footer-main {
  --text-primary: #eae8f0;
  --text-secondary: #b0a9c0;
  --text-muted: #706a82;
  --bg-footer: #0e0e18;
  --border-subtle: #1e1c2a;
}
.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1100px;
  margin: 0 auto;
  padding: 72px 24px 48px;
  gap: 48px;
  flex-wrap: wrap;
}
.footer-brand {
  max-width: 340px;
}
.footer-logo {
  font-family: var(--font-heading);
  font-size: 1.35em;
  font-weight: 800;
  background: var(--gradient-text);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.footer-ai {
  background: linear-gradient(135deg, #f472b6, #fb7185);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.footer-brand-text {
  font-size: 0.92em;
  color: var(--text-secondary);
  line-height: 1.7;
  margin: 0;
  font-family: var(--font-mono);
  letter-spacing: 0.2px;
}
.footer-columns {
  display: flex;
  gap: 64px;
}
.footer-col-title {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 700;
  color: var(--accent-purple);
  margin-bottom: 18px;
  letter-spacing: 3px;
  text-transform: uppercase;
  border-bottom: 2px solid var(--accent-purple);
  padding-bottom: 8px;
  display: inline-block;
}
.footer-link {
  font-family: var(--font-mono);
  font-size: 0.9em;
  color: var(--text-secondary);
  margin-bottom: 12px;
  cursor: pointer;
  transition: color 0.15s ease, letter-spacing 0.15s ease;
  letter-spacing: 0.5px;
}
.footer-link:hover {
  color: var(--text-primary);
  letter-spacing: 1px;
}
.footer-bottom {
  border-top: 1px solid var(--border-subtle);
  padding: 24px;
}
.footer-bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
}
.footer-copyright {
  font-family: var(--font-mono);
  font-size: 0.82em;
  color: var(--text-secondary);
  letter-spacing: 1px;
  text-transform: uppercase;
}
.footer-flag {
  margin-right: 6px;
  vertical-align: middle;
  border-radius: 2px;
}
.footer-socials {
  display: flex;
  gap: 16px;
  align-items: center;
}
.footer-social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  transition: color 0.15s ease;
  border-radius: 0px;
  box-shadow: none;
}
.footer-social-link:hover {
  color: var(--text-primary);
}

@media (max-width: 750px) {
  .footer-top {
    flex-direction: column;
    gap: 32px;
    padding: 48px 20px 36px;
  }
  .footer-columns {
    gap: 40px;
  }
}
</style>
